import React from 'react';
import { useFormContext } from 'react-hook-form';
const FinancialPOA = () => {
  const {
    register
  } = useFormContext();
  return <div className="space-y-8" data-id="element-481">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-482">
        <p className="text-slate-700" data-id="element-483">
          A Power of Attorney for Property gives someone else the legal
          authority to make decisions about your finances and property if you
          become unable to make these decisions yourself.
        </p>
      </div>
      {/* Primary Attorney */}
      <div className="space-y-4" data-id="element-484">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-485">
          Primary Attorney for Property
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-486">
          <div data-id="element-487">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-488">
              Name
              <span className="text-red-500 ml-1" data-id="element-489">*</span>
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter attorney's name" {...register('financialPOA.primary.name')} data-id="element-490" />
          </div>
          <div data-id="element-491">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-492">
              Relationship
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Spouse, Child, Friend" {...register('financialPOA.primary.relationship')} data-id="element-493" />
          </div>
          <div data-id="element-494">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-495">
              Phone Number
            </label>
            <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register('financialPOA.primary.phone')} data-id="element-496" />
          </div>
        </div>
        <div data-id="element-497">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-498">
            Address
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter attorney's address" {...register('financialPOA.primary.address')} data-id="element-499" />
        </div>
      </div>
      {/* Alternate Attorney */}
      <div className="space-y-4" data-id="element-500">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-501">
          Alternate Attorney for Property
        </h3>
        <p className="text-sm text-slate-600 mb-4" data-id="element-502">
          This person will act if your primary attorney is unable or unwilling
          to act.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-503">
          <div data-id="element-504">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-505">Name</label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate attorney's name" {...register('financialPOA.alternate.name')} data-id="element-506" />
          </div>
          <div data-id="element-507">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-508">
              Relationship
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Sibling, Friend" {...register('financialPOA.alternate.relationship')} data-id="element-509" />
          </div>
          <div data-id="element-510">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-511">
              Phone Number
            </label>
            <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register('financialPOA.alternate.phone')} data-id="element-512" />
          </div>
        </div>
        <div data-id="element-513">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-514">
            Address
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter alternate attorney's address" {...register('financialPOA.alternate.address')} data-id="element-515" />
        </div>
      </div>
      {/* Powers and Restrictions */}
      <div className="space-y-4" data-id="element-516">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-517">
          Powers and Restrictions
        </h3>
        <div data-id="element-518">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-519">
            Do you want to place any restrictions on your attorney's powers?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-520">
            <label className="inline-flex items-center" data-id="element-521">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('financialPOA.restrictions.exists')} data-id="element-522" />
              <span className="ml-2" data-id="element-523">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-524">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('financialPOA.restrictions.exists')} data-id="element-525" />
              <span className="ml-2" data-id="element-526">No</span>
            </label>
          </div>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Describe any restrictions you wish to place on your attorney's powers" {...register('financialPOA.restrictions.details')} data-id="element-527" />
        </div>
      </div>
    </div>;
};
export default FinancialPOA;